import React from 'react';

const WorksMiniNavbar = () => {
  return (
    <div data-wf--navbar-floating--variant="base" className="navbar_mini_wrap text-black fixed top-0 z-40 bg-white shadow-md w-full">
      <div className="navbar_mini_contain">
        <button 
          data-wf--btn-contact--variant="base" 
          data-link-hover="" 
          data-contact-btn=""
          className="btn_default_wrap"
        >
          <div className="btn_default_contain">
            <div data-link="" className="btn_default_text text-black">상담신청</div>
          </div>
          <div className="g_circle is-light invert"></div>
        </button>
      </div>
      <button data-link-hover="" data-menu-btn="" className="navbar_mini_btn text-black">
        <div className="navbar_menu_wrap">
          <div data-link="black" className="navbar_menu_innertext u-text-small">MENU</div>
        </div>
      </button>
    </div>
  );
};

export default WorksMiniNavbar;